import classnames from "@src/utils/classnames"
import React from "react"
import CardButton from "../button"
import * as styles from "./goodsCard.module.scss"

const GoodsCard = ({ className, thumb, title, disabled, ...resProps }) => {
  return (
    <CardButton
      disabled={disabled}
      {...resProps}
      className={classnames(styles.originalCard, className)}
    >
      <div
        className={styles.thumb}
        style={{ backgroundImage: `url(${thumb})` }}
      />
      <div className={styles.content}>
        <h3>{title}</h3>
        <div className={styles.btm}>
          {disabled ? "coming soon" : "了解更多>"}
        </div>
      </div>
    </CardButton>
  )
}

export default GoodsCard
